/* Knop 'Voeg er nog 1 toe' in het gratis-verzending-balkje (winkelwagen-lade en winkelwagenpagina). */
if (!window.freeShipAddBound) {
  window.freeShipAddBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-free-ship-add]');
    if (!btn) return;
    btn.setAttribute('aria-busy', 'true');

    // Meteen laten zien dat er iets gebeurt (het verzoek naar Shopify duurt ~0,5 s)
    var label = btn.querySelector('span:not(.free-shipping-bar__plus)');
    if (label && btn.dataset.busyText) label.textContent = btn.dataset.busyText;
    var bar = btn.closest('.free-shipping-bar');
    if (bar && btn.dataset.unlocks === 'true') {
      var fill = bar.querySelector('.free-shipping-bar__fill');
      var msg = bar.querySelector('.free-shipping-bar__message');
      if (fill) fill.style.width = '100%';
      if (msg && btn.dataset.doneText) msg.textContent = btn.dataset.doneText;
    }
    var drawer = btn.closest('cart-drawer');
    var body = { line: parseInt(btn.dataset.line, 10), quantity: parseInt(btn.dataset.quantity, 10) };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch(((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status || !drawer || !res.sections) {
          window.location.reload();
          return;
        }
        drawer.renderContents(res);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-shipping-bar' });
        }
      })
      .catch(function () { window.location.reload(); });
  });
}
